module.exports = tinymce;